import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode:"history",
  routes: [
    {
      path: '*',
      redirect: '/home'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/HomePage'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '汉工云-首页'
          }
        }
      ]
    },
    {
      path: '/employment',
      name: 'employment',
      component: resolve => require(['@/view/Employment'], resolve),
      meta: {
        title: '就业服务'
      }
    },
    {
      path: '/services/home',
      name: 'services',
      component: resolve => require(['@/view/services/Home'], resolve),
      meta: {
        title: '外包服务'
      }
    },
    {
      path: '/services/dispatch',
      name: 'services',
      component: resolve => require(['@/view/services/Dispatch'], resolve),
      meta: {
        title: '劳务派遣'
      }
    },
    // {
    //   path: '/services/flexible',
    //   name: 'services',
    //   component: resolve => require(['@/view/services/Flexible'], resolve),
    //   meta: {
    //     title: '灵活用工'
    //   }
    // },
    {
      path: '/services/job',
      name: 'services',
      component: resolve => require(['@/view/services/Job'], resolve),
      meta: {
        title: '岗位外包'
      }
    },
    {
      path: '/services/recruit',
      name: 'services',
      component: resolve => require(['@/view/services/Recruit'], resolve),
      meta: {
        title: '就业招聘'
      }
    }, 
    // {
    //   path: '/services/agency',
    //   name: 'services',
    //   component: resolve => require(['@/view/services/Agency'], resolve),
    //   meta: {
    //     title: '人事代理'
    //   }
    // }, 
    {
      path: '/services/guarantee',
      name: 'services',
      component: resolve => require(['@/view/services/Guarantee'], resolve),
      meta: {
        title: '残疾人就业保障'
      }
    },{
      path: '/services/welfare',
      name: 'services',
      component: resolve => require(['@/view/services/Welfare'], resolve),
      meta: {
        title: '员工福利'
      }
    },{
      path: '/saas',
      name: 'saas',
      component: resolve => require(['@/view/Saas'], resolve),
      meta: {
        title: 'SAAS服务'
      }
    }, 
    // {
    //   path: '/increase',
    //   name: 'increase',
    //   component: resolve => require(['@/view/Increase'], resolve),
    //   meta: {
    //     title: '产业园招商'
    //   }
    // }, 
    // {
    //   path: '/merchant',
    //   name: 'merchant',
    //   component: resolve => require(['@/view/Merchant'], resolve),
    //   meta: {
    //     title: '产业园招商'
    //   }
    // },  
    {
      path: '/aboutus',
      name: 'aboutus',
      component: resolve => require(['@/view/Aboutus'], resolve),
      meta: {
        title: '关于汉工云'
      }
    },  {
      path: '/contactus',
      name: 'contactus',
      component: resolve => require(['@/view/Contactus'], resolve),
      meta: {
        title: '联系汉工云'
      }
    },  {
      path: '/icon',
      name: 'icon',
      component: resolve => require(['@/view/Icon'], resolve),
      meta: {
        title: '图标库'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js